module.exports = __webpack_public_path__ + "videos/mts-products-chats-promo.349c3d1.webm";